import React from 'react';
import { MainLayoutHeader, MainLayoutHeaderProps } from '@app/components';

export const SettingHeader = ({ children }: Pick<MainLayoutHeaderProps, 'children'>) => {
  return (
    <MainLayoutHeader
      tabs={[
        {
          label: 'Business',
          subTabs: [
            { label: 'Restaurants', screenName: 'ShopScreen' },
            { label: 'Utilisateurs', screenName: 'UserScreen', permissions: ['dashboard::users.read'] },
            { label: 'Rôles', screenName: 'RoleScreen', permissions: ['dashboard::roles.read'] },
            { label: 'Organisation', screenName: 'OrganizationScreen', permissions: ['dashboard::organizations.read'] },
          ]
        },
        {
          label: 'Operationel',
          subTabs: [
            { label: 'Lieux de fabrication', screenName: 'KitchenAreaScreen', permissions: ['dashboard::kitchen-areas.read'] },
            { label: "Raisons d'annulations", screenName: "OrderCancelReasonScreen", permissions: ['dashboard::order-cancel-reasons.read'] },
            { label: "Zones de livraison", screenName: "DeliveryZoneScreen", permissions: ['dashboard::delivery-zones.read'] },
          ]
        },
        {
          label: 'Paiement & Finance',
          subTabs: [
            { label: 'Moyens de paiement', screenName: 'PaymentMethodScreen', permissions: ['dashboard::payment-methods.read'] },
            { label: 'Prestataires de paiement', screenName: 'PaymentProviderScreen', permissions: ['dashboard::payment-providers.read'] },
            { label: 'Taxes', screenName: 'TaxScreen', permissions: ['dashboard::taxes.read'] },
          ]
        },
        {
          label: 'Marketing',
          subTabs: [
            { label: 'Promotions', screenName: 'PromotionScreen', permissions: ['dashboard::promotions.read'] },
            { label: 'Publicités', screenName: 'PublicityScreen', permissions: ['dashboard::advertisements.read'] },
          ]
        },
        {
          label: 'Clients',
          subTabs: [
            { label: 'Fidélité', screenName: 'LoyaltyScreen', permissions: ['dashboard::loyalties.read'] },
          ]
        },
      ]}
    >
      {children}
    </MainLayoutHeader>
  );
};
